import { render, staticRenderFns } from "./BaseLink.global.vue?vue&type=template&id=367a30d3&"
import script from "./BaseLink.global.vue?vue&type=script&lang=js&"
export * from "./BaseLink.global.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports